import React from "react";
import ReactApexChart from "react-apexcharts";

const defaultCategories = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const defaultData = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

const getNiceMax = (maxVal) => {
    if (maxVal <= 0) return 10;
    const step = maxVal <= 10 ? 2 : maxVal <= 50 ? 10 : maxVal <= 200 ? 50 : 100;
    return Math.ceil((maxVal + 1) / step) * step;
};

const AreaChart = ({ data }) => {
    const rawValue = data?.value?.length ? data.value : defaultData;
    const value = rawValue.map((v) => Number(v) || 0);
    const categories = data?.label?.length ? data.label : defaultCategories;
    const maxCount = value.length ? Math.max(...value, 0) : 0;
    const yMax = getNiceMax(maxCount);
    const series = [
        {
            name: 'New Users',
            data: value
        },
    ];
    const options = {
        chart: {
            type: 'area',
            height: 350,
            stacked: false,
            toolbar: {
                show: false
            },
            zoom: {
                enabled: false
            }
        },
        colors: ["#B0DAED"],
        dataLabels: {
            enabled: false
        },
        tooltip: {
            enabled: true,
            y: {
                formatter: (val) => String(Math.round(val))
            }
        },
        xaxis: {
            categories,
            tickPlacement: 'on',
            labels: {
                style: {
                    fontSize: '14px',
                    fontWeight: 'medium',
                    colors: '#8C8E99'
                },
                rotate: 0,
                maxWidth: 120,
            },
            axisBorder: {
                show: true,
            },
            axisTicks: {
                show: false,
            },
            // title: {
            //     text: 'Month',
            //     style: {
            //         fontSize: '14px',
            //         fontWeight: 'medium',
            //         color: '#8C8E99'
            //     }
            // },
        },
        responsive: [
            {
                breakpoint: 992,
                options: {
                    xaxis: {
                        labels: {
                            rotate: -45,
                            style: { fontSize: '12px' },
                            maxWidth: 80,
                        },
                    },
                    chart: { height: 320 },
                },
            },
            {
                breakpoint: 768,
                options: {
                    xaxis: {
                        labels: {
                            rotate: -45,
                            style: { fontSize: '11px' },
                            maxWidth: 60,
                        },
                    },
                    chart: { height: 300 },
                },
            },
            {
                breakpoint: 576,
                options: {
                    xaxis: {
                        labels: {
                            rotate: -60,
                            style: { fontSize: '10px' },
                            maxWidth: 50,
                        },
                    },
                    chart: { height: 280 },
                },
            },
        ],
        yaxis: {
            min: 0,
            max: yMax,
            // tickAmount: 5,
            forceNiceScale: false,
            floating: false,
            labels: {
                formatter: (val) => String(Math.round(val)),
                style: {
                    fontSize: '14px',
                    fontWeight: 'medium',
                    colors: '#8C8E99'
                },
            },
            axisBorder: {
                show: true,
                width: 1,
            },
            title: {
                text: 'Users',
                style: {
                    fontSize: '14px',
                    fontWeight: 'medium',
                    color: '#8C8E99'
                }
            },
        },
        grid: {
            show: false,
        },
        legend: {
            show: false
        },
        stroke: {
            width: 2,
            curve: 'smooth',
        },
        fill: {
            type: 'gradient',
            gradient: {
                shade: 'light',
                type: 'vertical',
                shadeIntensity: 0.5,
                gradientToColors: ['#B0DAED'],
                opacityFrom: 0.6,
                opacityTo: 0.1,
                stops: [0, 90, 100],
            }
        },
    }

    return (
        <div className="w-100 overflow-hidden" style={{ minWidth: 0 }}>
            <ReactApexChart
                options={options}
                series={series}
                type="area"
                height={380}
            />
        </div>
    );
};

export default AreaChart;
